'use client'

import Link from 'next/link'
import { PageHeader, PageHeaderHeading } from '@/components/landing/page-header'
import { FaqStructuredData } from '@/components/seo/structured'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const faqs = [
  {
    question: 'Is BacklinkGPTcom free of charge?',
    answer: (
      <>
        Our subscription plans are not free, but we do offer a selection of
        <Link className="p-1 underline" href={'/free-seo-tools'}>
          free tools
        </Link>
        for you to test the paid version.
      </>
    ),
  },
  {
    question: 'How does the AI-generated outreach work?',
    answer: (
      <>
        BacklinkGPTcom leverages the power of GPT-4, a state-of-the-art AI language model, to craft
        personalized and relevant outreach messages for link-building efforts. The AI-generated
        messages are designed to improve the chances of securing valuable backlinks from targeted
        websites.
      </>
    ),
  },
  {
    question: 'Is my data secure on BacklinkGPTcom?',
    answer: (
      <>
        We take data security seriously at BacklinkGPTcom. We implement industry-standard security
        measures to ensure that your data is protected and stored safely.
      </>
    ),
  },
]

export const Faq = () => {
  return (
    <>
      <FaqStructuredData
        mainEntity={faqs.map((faq) => ({
          question: faq.question,
          answer: faq.answer.props.children,
        }))}
      />
      <PageHeader>
        <PageHeaderHeading className="text-xl md:text-4xl" level="h2">
          FAQ
        </PageHeaderHeading>

        <div className="mx-auto w-full max-w-xs md:mx-auto md:w-[1000px] md:max-w-3xl">
          <Accordion type="single" collapsible defaultValue="item-1">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index + 1}`}>
                <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
                <AccordionContent>
                  <div>{faq.answer}</div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </PageHeader>
    </>
  )
}
